/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppointmentModel } from '../models/AppointmentModel';
import type { VitecPersonLiteDto } from '../models/VitecPersonLiteDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BookingService {

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static bookingMakeBooking(
        requestBody?: AppointmentModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/Booking/MakeBooking',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param customerId
     * @param address
     * @param city
     * @param zipCode
     * @param userId
     * @param estateType
     * @param startDateTime
     * @param endDateTime
     * @param note
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static bookingPostVitecMeeting(
        customerId?: string,
        address?: string,
        city?: string,
        zipCode?: string,
        userId?: string,
        estateType?: string,
        startDateTime?: string,
        endDateTime?: string,
        note?: string,
        requestBody?: VitecPersonLiteDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/Booking/HandleVitecMeeting',
            query: {
                'CustomerId': customerId,
                'Address': address,
                'City': city,
                'ZipCode': zipCode,
                'UserId': userId,
                'estateType': estateType,
                'startDateTime': startDateTime,
                'endDateTime': endDateTime,
                'note': note,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
